import { useSession } from '@/contexts/LitSessionProvider';
import { getAuthId } from '@/lib/auth/getAuthId';
export default function useMFAUtilities({
  setLoading,
  setError
} = {}) {
  const {
    MFAInfo,
    setMFAInfo,
    PKP,
    litSession
  } = useSession();
  const ToggleMFA = async (authOverride, providerValue) => {
    setLoading && setLoading(true);
    try {
      if (!(authOverride || (MFAInfo === null || MFAInfo === void 0 ? void 0 : MFAInfo.authMethod))) {
        throw new Error('No MFA auth method provided');
      }
      if (authOverride) {
        console.log('Start addMFA');
        const authId = await getAuthId(authOverride, PKP, litSession);
        console.log('MFAInfoInToggle', MFAInfo, authOverride);
        const result = await fetch('/api/auth/mfa-info', {
          method: 'POST',
          body: JSON.stringify({
            dataToSave: {
              authMethodType: authOverride.authMethodType,
              authId: authId,
              providerValue: providerValue
            }
          })
        });
        const data = await result.json();
        if (data === null || data === void 0 ? void 0 : data.mfaInfo) {
          setMFAInfo(prev => Object.assign(Object.assign({}, prev), {
            providerValue,
            authMethod: authOverride,
            scopes: [false, true, true],
            presentMFAInfo: {
              authMethodType: data.mfaInfo.auth_method_type,
              authId: data.mfaInfo.auth_id
            }
          }));
          setMFAInfo(prev => Object.assign(Object.assign({}, prev), {
            MFALoggedIn: true,
            sessionSigs: true
          }));
        }
        console.log('End addMFA');
      } else {
        console.log('Start removeMFA');
        setMFAInfo(prev => Object.assign(Object.assign({}, prev), {
          authMethod: null,
          providerValue: null
        }));
        const result = await fetch('/api/auth/mfa-info', {
          method: 'POST',
          body: JSON.stringify({
            dataToSave: {
              authMethodType: null,
              authId: null,
              providerValue: null
            }
          })
        });
        const data = await result.json();
        console.log('remove mfa data', data);
        if (data === null || data === void 0 ? void 0 : data.mfaInfo) {
          setMFAInfo(prev => Object.assign(Object.assign({}, prev), {
            presentMFAInfo: null,
            sessionSigs: null
          }));
          setMFAInfo(prev => Object.assign(Object.assign({}, prev), {
            MFALoggedIn: false,
            sessionSigs: false
          }));
        }
        console.log('End removeMFA');
      }
      setError && setError(null);
      setLoading && setLoading(false);
      return {
        success: true
      };
    } catch (err) {
      console.error('[ToggleMFA]', err);
      setError && setError(err.message);
      setLoading && setLoading(false);
      return {
        success: false,
        error: err.message
      };
    } finally {
      setLoading && setLoading(false);
    }
  };
  return {
    ToggleMFA
  };
}